import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {auth, othersCollection} from './firebase'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
// import 'vue-select/dist/vue-select.css'; // Jeśli plik istnieje






Vue.config.productionTip = false
Vue.use(VModal)
Vue.use(VueToast)
Vue.component("v-select", vSelect);

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

let app

// Funkcja do inicjalizacji nasłuchiwania na kolekcję 'others'
let unsubscribeOthers = null;
function initOthersListener() {
  if (unsubscribeOthers) {
    unsubscribeOthers(); // Odsubskrybuj poprzedni listener jeśli istnieje
  }
  unsubscribeOthers = othersCollection.onSnapshot(snapshot => {
    let array = [];
    snapshot.forEach(doc => {
      let data = doc.data();
      data.id = doc.id;
      array.push(data);
    });
    store.commit('setOthers', array);
  });
}

auth.onAuthStateChanged(user => {
  if(!app) {
    app = new Vue({
      router,
      store,
      render: h=> h(App)
    }).$mount('#app')
  }
  if (user) {
    store.dispatch('fetchUserProfile', user)
    initOthersListener(); // Zawsze aktywuj nasłuchiwanie na kolekcję 'others' po zalogowaniu
  } else {
    if (unsubscribeOthers) {
      unsubscribeOthers();
      unsubscribeOthers = null;
    }
    store.commit('setOthers', []); // Wyczyść dane others po wylogowaniu
  }
})